import { useMemo } from "react";

import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductPlanFormModelContext } from "../../../../../context";

export const usePlanRequiredOptionGroupIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductPlanFormModelContext();
	const { availableOptionIDs, requiredOptionGroupIDs, hotelID } = viewModel;
	const { optionNameAndIDOptions } = queryData.connection;

	const rawAvailableOptionsIDs = availableOptionIDs.value.map((item) => item.value);
	const requiredOptionsNameAndIDOptions = useMemo(
		() => optionNameAndIDOptions.filter((item) => rawAvailableOptionsIDs.includes(item.value)),
		[optionNameAndIDOptions, rawAvailableOptionsIDs],
	);

	const isEdited = useMemo(() => {
		return requiredOptionGroupIDs.isEdited;
	}, [requiredOptionGroupIDs.isEdited]);

	return {
		...useConnection<"requiredOptionGroupIDs">({
			availableItemIDs: requiredOptionGroupIDs, //
			nameAndIDOptions: requiredOptionsNameAndIDOptions,
			keyOfValue: "requiredOptionGroupIDs",
			onSetViewModel,
		}),
		hotelID,
		isEdited,
	};
};
